module.exports = __webpack_public_path__ + "img/px_pc2.25192749.png";